import { Overline, MaskedLines } from "./Reveal";

// Editorial header block for inner pages
export function PageIntro({ overline, title, body, testId }) {
  const lines = title.split("\n");
  return (
    <section className="relative overflow-hidden pt-36 pb-16 lg:pt-44 lg:pb-24" data-testid={testId}>
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Overline>{overline}</Overline>
        <h1 className="mt-6 max-w-4xl font-serif text-5xl font-light leading-[0.95] tracking-tight text-charcoal sm:text-6xl lg:text-7xl">
          <MaskedLines lines={lines} />
        </h1>
        {body && <p className="mt-8 max-w-2xl text-lg leading-relaxed text-charcoal/70">{body}</p>}
      </div>
    </section>
  );
}
